<template>
  <div :class = 'classes'>
    <div class = 'unit-content'>
      <div class = 'wrap'>
        <div :class = '{"concentration-line": unit.type === "concentration"}'></div>
        <i v-if = 'unit.type === "concentration"' class = 'fas fa-circle concentration-icon'></i>
        <div class = 'unit-name'>
          <div class = 'unit-name-wrap'>
            <div class = 'unit-type'>{{ unit.type }}</div>
            {{ label }}
          </div>
        </div>
        <template v-if = 'active'>
          <div class = 'unit-level'>
            <span v-if='level'>{{ level }}</span>
          </div>
          <div class = 'unit-period-select'>
            <multiselect
              v-if = 'unit.planPeriods.length > 0'
              :options = 'unit.planPeriods'
              v-model = 'period'
              track-by = 'id'
              label = 'name'
              selected-label = ''
              deselect-label = ''
              select-label = ''
              placeholder = 'Select Period'
            >
            </multiselect>
            <span v-else>&nbsp;</span>
          </div>

          <!-- <router-link :to = '{ name: "unit-info", params: unitParams }' v-if = 'unit.cip_code'>
            <button v-if = 'unit.hasInfo || unit.cip_code' class = 'hollow'><span>{{ unit.type }}</span> Info</button>
          </router-link> -->
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['unit'],

  data() {
    return {
      period: null
    }
  },

  watch: {
    period() {
      this.goToPlans()
    }
  },

  computed: {
    level() {
      if (this.unit.sub_program_level) {
        return this.unit.sub_program_level.code
      } else if (this.unit.program_level) {
        return this.unit.program_level.code
      } else {
        return ''
      }
    },
    label() {
      return `${this.name}`// (${this.code})`
    },
    name() {
      return (this.unit[this.unit.type] || {}).name
    },
    active() {
      return !this.unit.inactive
    },
    periodId() {
      return this.$store.getters.currentPeriod.id
    },
    planString() {
      return this.plan_count > 1 ? 'Plans' : 'Plan'
    },
    planCount() {
      return this.planPeriod.plan_count
    },
    planPeriod() {
      return this.unit.currentPlanPeriod
    },
    classes() {
      return {
        'unit-item': true,
        'major-listing': true,
        'active': this.active
      }
    },
    unitParams() {
      return {
        period_id: this.periodId,
        layout_id: this.unit.university_layout_id
      }
    }
  },

  methods: {
    goToPlans() {
      if (this.active) {
        this.$router.push({
          name: 'unit-plans',
          params: {
            period_id: this.period.id,
            layout_id: this.unit.university_layout_id
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// unit_archived.vue?40690747